import { AppOwnerRoleType } from 'ox-common-types';
export interface ActiveMember {
  user_id: string;
  name: string;
  picture: string;
  email: string;
  roles: Role[];
  relatedIDs: string[];
  kind: MemberKind.ActiveMember | MemberKind.PendingInvitationMember;
}

export enum MemberKind {
  ActiveMember = 'ActiveMember',
  PendingInvitationMember = 'PendingInvitationMember',
}

interface Role {
  id: string;
  name: RoleName;
  description: string;
}

export enum RoleName {
  Admin = 'Admin',
  ReadOnly = 'Read Only',
}

export interface AppOwnersByAppIdInput {
  appIds: string[];
  roles: AppOwnerRoleType[];
}

export interface AppOwnerData {
  email?: string;
  name?: string;
  emptyAppOwners?: boolean;
  appIds: string[];
}

export interface AppOwnersByRole {
  owners: AppOwnerData[];
  role: AppOwnerRoleType;
}
